const env = process.env;
const isProd = env.NODE_ENV === "production";

console.log(env);

export const urlConfig = {
  BASE_URL: env.REACT_APP_BASE_URL || "https://strapi-r94w.onrender.com",
};
